import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import NotFoundView from '@/views/NotFoundView'
import OidcCallbackView from '@/views/OidcCallbackView'
import MyAccountView from '@/views/MyAccountView'
import settings from '@/settings/settings'
import { routes } from './routes'
import RedirectView from '@/views/RedirectView'
const RouteObj = routes[settings.LOCALE]

Vue.use(Router)
Vue.use(Meta)
RouteObj.routes.push({
  path: '/redirect/:uuid/',
  name: 'redirectView',
  component: RedirectView,
})

RouteObj.routes.push({
  path: '/offer/:uuid/basisbank-eskat-success',
  name: 'basisbank-eskat-success',
  component: MyAccountView,
  props: { eskatSuccess: true },
})

RouteObj.routes.push({
  path: '/offer/:uuid/basisbank-eskat-failure',
  name: 'basisbank-eskat-failure',
  component: MyAccountView,
  props: { eskatFailure: true },
})

RouteObj.routes.push({
  path: '/oidc-callback', // Needs to match redirect_uri in you oidcSettings
  name: 'oidcCallbackView',
  component: OidcCallbackView,
  meta: {
    isPublic: true,
    isOidcCallback: true,
    title: 'Min konto - Saverium.dk',
  },
})

// Common 404 route, has to be added last
RouteObj.routes.push({
  path: '*',
  name: 'NotFoundView',
  component: NotFoundView,
  meta: {
    title: 'Saverium.dk',
  },
})
const router = new Router({
  mode: 'history',
  routes: RouteObj.routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})
// Version id for A/B testing. If versionId = 1, form will have new input fields in loan amount and repayment time
// If versionId = 0, form will have the old sliders
const versionId = Math.floor(Math.random() * 2)

// Middleware for manipulating different scenarios inside app
router.beforeEach((to, from, next) => {
  // set page title from meta
  document.title = to.meta.title
  document.head.querySelector('meta[name=description]').content = to.meta.description
  document.head.querySelector('meta[property="og:description"]').content =
    to.meta.description
  document.head.querySelector('meta[property="og:image"]').content = to.meta.img
  Vue.saverium.getSessionKeyValue({ query: to.query })
  Vue.saverium.getFbClickValue({ query: to.query })
  Vue.saverium.setVersionId(versionId)
  if (to.meta.requireLogin) {
    Vue.saverium.oidcUserManager.getUser().then(user => {
      if (user) {
        next()
      } else {
        next({
          path: '/login',
          query: { next: to.fullPath },
          replace: true,
        })
      }
    })
  } else {
    next()
  }
})

export default router
